import pick from 'lodash/pick';

/**
 * Returns a subset of the given state by picking only the specified keys.
 *
 * This is typically used to define which parts of a store should be persisted
 * when using the `persist` middleware.
 *
 * @param state - The full state object of the store.
 * @param keys - An array of keys to retain from the state.
 * @returns A new state object containing only the specified keys.
 */
export const pickState = <T>(state: T, keys: string[]): T => {
  return pick(state, keys) as T;
};
